function FaqQuestionsModel({ id, title, answer, }) {
  let obj = {};
  obj.id = id;
  obj.title = title;
  obj.answer = answer;
  return obj;
}

export default FaqQuestionsModel;